import { RawDraftContentState } from "draft-js";

import { IStaticInfo } from "./index.d";
import { handleApiGet, handleApiPut, definedFooterRoutes } from "./api";
import { BackendUrl } from "./newBackendApi";

export function getStaticData(type: string) {
  return handleApiGet(
    `${BackendUrl}/get-item/static-page/${encodeURIComponent(type)}`,
  );
}

export function updateStaticData(
  idToken: string,
  type: definedFooterRoutes,
  description: RawDraftContentState,
) {
  return handleApiPut(
    `${BackendUrl}/admin/put-item/static-page/${encodeURIComponent(type)}`,
    idToken,
    { description },
  );
}

export function updateContact(idToken: string, contact: IStaticInfo) {
  const { slug, title, description, email, phone, imageUrl } = contact;
  return handleApiPut(
    `${BackendUrl}/admin/put-item/contacts/${encodeURIComponent(slug)}`,
    idToken,
    {
      title,
      description,
      // Cleared inputs leave "", which the schema rejects
      email: email?.filter(Boolean),
      phone: phone?.filter(Boolean),
      imageUrl: imageUrl || undefined,
      show: Number(contact.show),
      displayInHomePage:
        contact.displayInHomePage === undefined
          ? undefined
          : Number(contact.displayInHomePage),
    },
  );
}
